import PropTypes from 'prop-types';
import React, { useCallback, useEffect } from 'react';
import classnames from 'classnames';
import { useIntl } from 'react-intl';
import { NOTIFICATION_TYPE } from 'src/modules/Notification';

import Button from 'src/components/Button';
import theme from 'src/styles/components/OrderStatus.module.scss';
import router from 'next/router';

const PublishMenuBar = ({
    isPublished,
    pushNotification,
    token,
    publishNewMenu,
    publishNewMenuError,
    clearPublishNewMenu,
    slug
}) => {
    const intl = useIntl();

    useEffect(() => {
        if (!publishNewMenuError) {
            return;
        }

        pushNotification({
            type: NOTIFICATION_TYPE.ACCEPT,
            message: (
                <div className={theme.notification}>
                    <div className={theme.notificationIcon}>
                        <span className="icon-info" />
                    </div>
                    {intl.formatMessage({ id: publishNewMenuError })}
                </div>
            ),
            timeout: 3000,
            onTimeout: clearPublishNewMenu,
            onDismiss: clearPublishNewMenu
        });
    }, [publishNewMenuError]);

    useEffect(() => {
        if (!isPublished) {
            return;
        }

        pushNotification({
            type: NOTIFICATION_TYPE.ACCEPT,
            message: (
                <div className={theme.notification}>
                    <div className={theme.notificationIcon}>
                        <span className="icon-info" />
                    </div>
                    {intl.formatMessage({ id: 'App.yourMenuHasBeenPublished' })}
                </div>
            ),
            timeout: 5000,
            onTimeout: () => { router.push(`/${slug}`); },
            onDismiss: () => { router.push(`/${slug}`); }
        });
    }, [isPublished, slug]);

    const handlePublishMenu = useCallback(() => {
        publishNewMenu(token);
    }, [token]);

    if (isPublished) {
        return null;
    }

    return (
        <div className={classnames(
              theme.container,
              theme.visible
          )}
        >
            <div className={theme.content}>
                <div className={theme.buttonsContainer}>
                    <Button
                      className={classnames(theme.button, theme.orderButton, theme.active)}
                      accent
                      raised
                      onClick={handlePublishMenu}
                    >
                        <span className={classnames('icon-menu')} />
                        <span className={theme.description}>{intl.formatMessage({ id: 'App.publishMyMenu' })}</span>
                    </Button>
                </div>
            </div>
        </div>
    );
};

PublishMenuBar.propTypes = {
    isPublished: PropTypes.bool,
    pushNotification: PropTypes.func.isRequired,
    token: PropTypes.string.isRequired,
    publishNewMenu: PropTypes.func.isRequired,
    publishNewMenuError: PropTypes.string,
    clearPublishNewMenu: PropTypes.func.isRequired,
    slug: PropTypes.string.isRequired
};

export default PublishMenuBar;
